// Validación de CUIL/CUIT (Argentina) — dígito verificador mód-11 + prefijos.

// ── Núcleo compartido: la matemática del dígito verificador (igual para CUIT y CUIL) ──
function _validarBase(valor) {
  const num = String(valor).replace(/[-\s]/g, "");
  if (!/^\d{11}$/.test(num)) return { ok: false, num: null };

  const pesos = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const suma = pesos.reduce((acc, p, i) => acc + p * Number(num[i]), 0);
  let verif = 11 - (suma % 11);
  if (verif === 11) verif = 0;
  else if (verif === 10) verif = 9;

  return { ok: verif === Number(num[10]), num };
}

// ── Campo CUIL: solo personas físicas (20, 23, 24, 27) ──
export function validarCUIL(valor) {
  const { ok, num } = _validarBase(valor);
  if (!ok) return false;
  const prefijosCUIL = ["20", "23", "24", "27"];
  return prefijosCUIL.includes(num.slice(0, 2));
}

// ── Campo CUIT: personas físicas + jurídicas (empresas) ──
export function validarCUIT(valor) {
  const { ok, num } = _validarBase(valor);
  if (!ok) return false;
  const prefijosCUIT = ["20", "23", "24", "27", "30", "33", "34"];
  return prefijosCUIT.includes(num.slice(0, 2));
}

// ── Formato de visualización: xx-xxxxxxxx-x (sobre los dígitos crudos) ──
export function formatCuit(valor) {
  const d = String(valor || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 10) return `${d.slice(0, 2)}-${d.slice(2)}`;
  return `${d.slice(0, 2)}-${d.slice(2, 10)}-${d.slice(10)}`;
}
